(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["barra-compra"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function formatPrice(cents, withCurrency) {
      var amount = (Number(cents) || 0) / 100;
      var text = '$' + amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return withCurrency ? text + ' MXN' : text;
    }

    function findMainButton(bar) {
      var buttons = document.querySelectorAll('.add-to-cart-button, [id^="BuyButtons-ProductSubmitButton-"], form[action*="/cart/add"] [type="submit"]');
      for (var i = 0; i < buttons.length; i++) {
        if (!bar.contains(buttons[i])) return buttons[i];
      }
      return null;
    }

    /* ---------- Chat de IA, aviso de descuento y otros flotantes ----------
       Mientras la barra esta visible se ocultan. Si el cliente abre el chat
       o aparece un popup grande, ellos se muestran y la barra se esconde. */
    var WIDGET_HOSTS = '#ads-agent-host, shopify-forms-embed, inbox-online-store-chat, shopify-chat, gty-whatsapp-chat-button';

    function setupLift(bar) {
      if (bar.dataset.lift !== 'true') return;
      if (window.__fgLiftLoaded) return;
      window.__fgLiftLoaded = true;

      var body = document.body;
      var timer = null;

      function isShown(el, cs) {
        if (cs.display === 'none') return false;
        if (cs.visibility === 'hidden') return false;
        if (parseFloat(cs.opacity) < 0.05) return false;
        return true;
      }

      /* Hay un panel grande abierto (chat abierto, popup de descuento)? */
      function bigPanelOpen() {
        var vw = window.innerWidth;
        var vh = window.innerHeight;
        var hosts = document.querySelectorAll(WIDGET_HOSTS);
        for (var h = 0; h < hosts.length; h++) {
          var host = hosts[h];
          if (host.contains(bar)) continue;
          var scope = host.shadowRoot || host;
          var nodes = scope.querySelectorAll('*');
          var max = Math.min(nodes.length, 4000);
          for (var i = 0; i < max; i++) {
            var el = nodes[i];
            var tag = el.tagName;
            if (tag === 'STYLE' || tag === 'LINK' || tag === 'SCRIPT') continue;
            var cs = window.getComputedStyle(el);
            if (cs.position !== 'fixed') continue;
            if (!isShown(el, cs)) continue;
            var r = el.getBoundingClientRect();
            if (r.width > vw * 0.6 && r.height > vh * 0.3) return true;
          }
        }
        return false;
      }

      function apply() {
        if (!bar.classList.contains('is-visible')) {
          body.classList.remove('fg-hide-widgets', 'fg-bar-yield');
          return;
        }
        if (bigPanelOpen()) {
          body.classList.remove('fg-hide-widgets');
          body.classList.add('fg-bar-yield');
        } else {
          body.classList.remove('fg-bar-yield');
          body.classList.add('fg-hide-widgets');
        }
      }

      function schedule(delay) {
        clearTimeout(timer);
        timer = setTimeout(apply, delay || 30);
      }

      new MutationObserver(function () { schedule(20); }).observe(bar, { attributes: true, attributeFilter: ['class'] });
      setInterval(function () {
        if (bar.classList.contains('is-visible')) apply();
      }, 700);
      schedule(300);
    }

    function initBar(bar) {
      if (!bar || bar.dataset.bcReady === 'true') return;
      bar.dataset.bcReady = 'true';

      /* Evita que las animaciones de la pagina atrapen la barra */
      var ownSection = bar.closest('.shopify-section');
      if (ownSection) {
        ownSection.classList.remove('fg-reveal');
        ownSection.classList.add('fg-in');
      }
      var inEditor = bar.dataset.designMode === 'true' || (window.Shopify && window.Shopify.designMode);
      if (!inEditor && bar.parentElement !== document.body) {
        document.body.appendChild(bar);
      }

      var designMode = bar.dataset.designMode === 'true';
      var withCurrency = bar.dataset.showCurrency === 'true';
      var showBtnPrice = bar.dataset.showBtnPrice === 'true';
      var button = bar.querySelector('[data-bc-button]');
      var label = bar.querySelector('[data-bc-button-label]');
      var priceEl = bar.querySelector('[data-bc-price]');
      var compareEl = bar.querySelector('[data-bc-compare]');
      var percentEl = bar.querySelector('[data-bc-percent]');
      var variantEl = bar.querySelector('[data-bc-variant]');
      var imageEl = bar.querySelector('[data-bc-image]');
      var variantIdInput = bar.querySelector('[data-bc-variant-id]');
      var form = bar.querySelector('[data-bc-form]');
      var currentPrice = priceEl ? priceEl.textContent.trim() : '';
      var mainButton = findMainButton(bar);

      function setVisible(visible) {
        if (designMode) visible = true;
        bar.classList.toggle('is-visible', visible);
        bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
        document.body.style.paddingBottom = visible ? bar.offsetHeight + 'px' : '';
      }

      function setAvailable(available) {
        if (!button) return;
        button.disabled = !available;
        if (label) {
          label.textContent = available
            ? button.dataset.label + (showBtnPrice && currentPrice ? ' \u00b7 ' + currentPrice : '')
            : button.dataset.soldoutLabel;
        }
      }

      if (designMode) setVisible(true);

      var target = mainButton ? (mainButton.closest('.product-form-buttons') || mainButton) : null;
      if (target && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            setVisible(scrolledPast);
          });
        });
        observer.observe(target);
      } else if (!target) {
        window.addEventListener('scroll', function () {
          setVisible(window.scrollY > window.innerHeight * 0.9);
        }, { passive: true });
      }

      if (mainButton && 'MutationObserver' in window) {
        new MutationObserver(function () {
          setAvailable(!mainButton.disabled);
        }).observe(mainButton, { attributes: true, attributeFilter: ['disabled'] });
      }

      if (button) {
        button.addEventListener('click', function () {
          if (button.disabled) return;
          mainButton = findMainButton(bar) || mainButton;
          if (mainButton && !mainButton.disabled) {
            button.classList.add('is-loading');
            mainButton.click();
            setTimeout(function () { button.classList.remove('is-loading'); }, 1200);
          } else if (form) {
            form.submit();
          }
        });
      }

      document.addEventListener('variant:update', function (event) {
        var variant = event.detail && event.detail.resource;
        if (!variant) return;
        if (variant.price !== undefined) {
          currentPrice = formatPrice(variant.price, withCurrency);
          if (priceEl) priceEl.textContent = currentPrice;
        }
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (priceEl) priceEl.classList.toggle('is-sale', !!onSale);
        if (compareEl) {
          compareEl.hidden = !onSale;
          if (onSale) compareEl.textContent = formatPrice(variant.compare_at_price, withCurrency);
        }
        if (percentEl) {
          percentEl.hidden = !onSale;
          if (onSale) {
            var pct = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
            percentEl.textContent = '(-' + pct + '%)';
          }
        }
        if (variantEl && variant.title) variantEl.textContent = variant.title;
        if (variantIdInput && variant.id) variantIdInput.value = variant.id;
        var imgSrc = variant.featured_image && (variant.featured_image.src || variant.featured_image.url);
        if (imageEl && imgSrc) {
          imageEl.src = imgSrc + (imgSrc.indexOf('?') === -1 ? '?' : '&') + 'width=160';
          imageEl.removeAttribute('srcset');
        }
        if (variant.available !== undefined) setAvailable(variant.available);
        else setAvailable(true);
      });

      setupLift(bar);
    }

    function initAll(root) {
      (root || document).querySelectorAll('[data-barra-compra]').forEach(initBar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["piramide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function revealSection(section) {
      section.classList.add('is-visible');
    }

    function initPiramide(root) {
      var scope = root || document;
      var sections = scope.querySelectorAll('[data-po-section]');

      sections.forEach(function (section) {
        if (section.dataset.poReady === 'true') return;
        section.dataset.poReady = 'true';

        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!section.hasAttribute('data-po-animate') || reduceMotion || !('IntersectionObserver' in window)) {
          revealSection(section);
          return;
        }

        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                revealSection(section);
                observer.disconnect();
              }
            });
          },
          { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
        );

        observer.observe(section);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initPiramide();
      });
    } else {
      initPiramide();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initPiramide(event.target);
    });

    document.addEventListener('shopify:block:select', function (event) {
      var tier = event.target;
      if (!tier || !tier.classList || !tier.classList.contains('po-tier')) return;
      tier.classList.add('is-selected');
      var section = tier.closest('[data-po-section]');
      if (section) revealSection(section);
    });

    document.addEventListener('shopify:block:deselect', function (event) {
      var tier = event.target;
      if (tier && tier.classList) tier.classList.remove('is-selected');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rede-sociales"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRedes(root) {
      if (!root || root.dataset.redesReady === 'true') return;
      root.dataset.redesReady = 'true';

      var track = root.querySelector('[data-redes-track]');
      var prev = root.querySelector('[data-redes-prev]');
      var next = root.querySelector('[data-redes-next]');
      if (!track) return;

      function step() {
        var card = track.querySelector('.redes__card');
        if (!card) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card.offsetWidth + gap;
      }

      function updateArrows() {
        var maxScroll = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= maxScroll;
      }

      if (prev) prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });

      if (next) next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-redes]').forEach(initRedes);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
